import React from "react";
import ContactUs from "..//contact-us";

const PricingPage = () => {
  const providers = ["MTN", "Airtel", "Glo", "9Mobile"];
  const volumeRanges = [
    "0-200,000",
    "201,000-1m",
    "1m - 5m",
    "5m - 10m",
    "10m+",
  ];
  const promotionalRates = [
    [2.1, 2.0, 1.9, 1.85, "Negotiable"],
    [2.1, 2.0, 1.9, 1.85, "Negotiable"],
    [2.1, 2.0, 1.9, 1.85, "Negotiable"],
    [2.1, 2.0, 1.9, 1.85, "Negotiable"],
  ];

  const transactionalRates = [
    [2.8, 2.7, 2.6, 2.5, "Negotiable"],
    [2.8, 2.7, 2.6, 2.5, "Negotiable"],
    [2.8, 2.7, 2.6, 2.5, "Negotiable"],
    [2.8, 2.7, 2.6, 2.5, "Negotiable"],
  ];
  return (
    <main className="max-w-screen-xl mx-auto py-32 space-y-20">
      <section
        style={{
          backgroundImage: `url('${"https://res.cloudinary.com/dbpb7sjus/image/upload/v1744332918/pricing-hero-bg_jpb0fi.png"}')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
        className="text-white bg-primary bg-right md:bg-contain bg-no-repeat rounded-xl p-10 md:pt-28 md:pb-40 md:px-20 mx-6 relative text-center md:text-center"
      >
        <div className="flex flex-col justify-center">
          <p className="text-2xl md:text-5xl font-semibold max-w-xl">
            Low Prices you Can Always Trust.
          </p>
          <p className="text-2xs md:text-sm font-light mt-6 max-w-xl">
            At SleengShort, we believe in providing affordable, transparent, and
            scalable pricing to meet the unique needs of your business. Whether
            you’re a small startup or a large enterprise, our pricing plans are
            designed to help you connect with your audience without breaking the
            bank.
          </p>
        </div>
      </section>

      {/* pricing plans for promotional marketing messages */}
      <div className="px-8 md:px-0">
        <h3 className="font-medium text-xl md:text-3xl text-center md:text-left mb-6">
          Promotional Marketing Messages &#40;Naira&#41;
        </h3>

        <div className="bg-white md:bg-transparent w-full overflow-x-auto">
          <table className="w-full border-collapse min-w-max">
            <thead>
              <tr className="text-center">
                <th className="py-4"></th>
                {volumeRanges.map((range, index) => (
                  <th
                    key={index}
                    className="py-4 px-6 font-semibold text-gray-700 text-xs md:text-base"
                  >
                    {range}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {providers.map((provider, providerIndex) => (
                <React.Fragment key={provider}>
                  <tr className="border-y border-primary">
                    <td className="py-4 px-4 font-medium text-xs md:text-base">
                      {provider}
                    </td>
                    {transactionalRates[providerIndex].map(
                      (rate, rateIndex) => (
                        <td
                          key={rateIndex}
                          className="py-4 px-6 text-center text-gray-700 text-xs md:text-base"
                        >
                          {typeof rate === "number" ? rate.toFixed(2) : rate}
                        </td>
                      )
                    )}
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* pricing plans for transactional/corporate messages */}
      <div className="px-8 md:px-0">
        <h3 className="font-medium text-xl md:text-3xl text-center md:text-left mb-6">
          Transactional/Corporate Messages &#40;Naira&#41;
        </h3>

        <div className="bg-white md:bg-transparent w-full overflow-x-auto">
          <table className="w-full border-collapse min-w-max">
            <thead>
              <tr className="text-center">
                <th className="py-4"></th>
                {volumeRanges.map((range, index) => (
                  <th
                    key={index}
                    className="py-4 px-6 font-semibold text-gray-700 text-xs md:text-base"
                  >
                    {range}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {providers.map((provider, providerIndex) => (
                <React.Fragment key={provider}>
                  <tr className="border-y border-primary">
                    <td className="py-4 px-4 font-medium text-xs md:text-base">
                      {provider}
                    </td>
                    {promotionalRates[providerIndex].map((rate, rateIndex) => (
                      <td
                        key={rateIndex}
                        className="py-4 px-6 text-center text-gray-700 text-xs md:text-base"
                      >
                        {typeof rate === "number" ? rate.toFixed(2) : rate}
                      </td>
                    ))}
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* contact us */}
      <ContactUs />
    </main>
  );
};

export default PricingPage;
